import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  SET_ACTIVE_STATE,
  SHOW_MANAGER_EXT_DIALOG
} from './actionTypes'
import { RTM_MANAGER_WORKING_STATE_CHANGED } from '../socket/actionTypes'
// import { getSessionList } from './selectors'
import { getCurrentUser } from '../user/selectors'
import { getCurrentUser as fetchCurrentUser } from '../user/actions'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'
import * as apis from '@/apis'

const tenantMode = process.env.APP_MODE === 'tenant'


export default {
  *[RTM_MANAGER_WORKING_STATE_CHANGED]({ payload }) {
    if (!tenantMode) {
      yield put(fetchCurrentUser())
    }
  },
  *[FETCH_LIST]({ payload }) { // 获取分组列表数据
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('SKILLS_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[SET_ACTIVE_STATE]({ payload }) {
    const { id, isActive } = payload

    yield call(services.setActiveState, id, isActive)
    yield put(actions.updated(id, { isActive }))

    message.success('设置完成')
    // setActiveState
  },

  *[SHOW_MANAGER_EXT_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('CHANGE_MANAGER_EXT_DIALOG')
    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
}
